<template>
  <div class="min-h-screen">
    <AppNavbar />

    <section class="page-gutter section-gap pt-32">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h1 class="text-4xl sm:text-5xl font-extrabold">Pricing</h1>
          <p class="text-muted mt-3">All plans are subscriptions billed monthly.</p>
          <p class="text-muted text-sm mt-2">You can subscribe in the App to Link mobile app.</p>
        </div>

        <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          <!-- Free -->
          <div class="card flex flex-col">
            <div class="mb-4">
              <h3 class="text-2xl font-bold">Free</h3>
              <div class="mt-2 flex items-baseline gap-2 text-4xl font-extrabold whitespace-nowrap leading-none">
                <span class="gradient-text">$0</span>
                <span class="text-base text-muted">/ month</span>
              </div>
            </div>
            <ul class="space-y-3 text-muted flex-1">
              <li class="flex items-start gap-3"><span>3 active links</span></li>
              <li class="flex items-start gap-3"><span>1 account</span></li>
              <li class="flex items-start gap-3"><span>Total click count</span></li>
            </ul>
          </div>

          <!-- Starter -->
          <div class="card flex flex-col">
            <div class="mb-4">
              <h3 class="text-2xl font-bold">Starter</h3>
              <div class="mt-2 flex items-baseline gap-2 text-4xl font-extrabold whitespace-nowrap leading-none">
                <span class="gradient-text">$9.99</span>
                <span class="text-base text-muted">/ month</span>
              </div>
            </div>
            <ul class="space-y-3 text-muted flex-1">
              <li class="flex items-start gap-3"><span>500 active links</span></li>
              <li class="flex items-start gap-3"><span>3 accounts</span></li>
              <li class="flex items-start gap-3"><span>Daily click stats (7-day summary)</span></li>
              <li class="flex items-start gap-3"><span>Push notifications (daily / per 100 clicks)</span></li>
              <li class="flex items-start gap-3"><span>Link Tags</span></li>
            </ul>
          </div>

          <!-- Pro -->
          <div class="card flex flex-col border-primary-500 relative">
            <div class="absolute top-4 right-6 inline-block text-xs uppercase tracking-wide px-2 py-1 rounded-full border border-primary-500 text-primary-400 pointer-events-none select-none">Most Popular</div>
            <div class="mb-4">
              <h3 class="text-2xl font-bold">Pro</h3>
              <div class="mt-2 flex items-baseline gap-2 text-4xl font-extrabold whitespace-nowrap leading-none">
                <span class="gradient-text">$19.99</span>
                <span class="text-base text-muted">/ month</span>
              </div>
            </div>
            <ul class="space-y-3 text-muted flex-1">
              <li class="flex items-start gap-3"><span>1000 active links</span></li>
              <li class="flex items-start gap-3"><span>5 accounts</span></li>
              <li class="flex items-start gap-3"><span>Top Performing Links (top 3 by clicks)</span></li>
              <li class="flex items-start gap-3"><span>Click Insights Card (mini dashboard)</span></li>
              <li class="flex items-start gap-3"><span>Pinned Links (pin to top)</span></li>
              <li class="flex items-start gap-3"><span>Smart Suggestion ("This link is getting lots of clicks!")</span></li>
            </ul>
          </div>

          <!-- Unlimited -->
          <div class="card flex flex-col">
            <div class="mb-4">
              <h3 class="text-2xl font-bold">Enterprise</h3>
              <div class="mt-2 flex items-baseline gap-2 text-4xl font-extrabold whitespace-nowrap leading-none">
                <span class="gradient-text">$49.99</span>
                <span class="text-base text-muted">/ month</span>
              </div>
            </div>
            <ul class="space-y-3 text-muted flex-1">
              <li class="flex items-start gap-3"><span>10,000 active links</span></li>
              <li class="flex items-start gap-3"><span>20 accounts</span></li>
              <li class="flex items-start gap-3"><span>Full Analytics Dashboard (daily/weekly trends)</span></li>
              <li class="flex items-start gap-3"><span>CSV Export</span></li>
              <li class="flex items-start gap-3"><span>Premium push reports (weekly summary, performance alerts)</span></li>
            </ul>
          </div>
        </div>
        <p class="text-center text-xs text-muted mt-10">Prices may change on mobile apps.</p>
      </div>
    </section>

    <footer class="page-gutter py-8 border-t border-border">
      <div class="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p class="text-muted text-sm">© 2024 App to Link. All rights reserved.</p>
        <nav class="flex items-center gap-6 text-sm text-muted">
          <router-link to="/" class="hover:text-text transition">Home</router-link>
          <router-link to="/privacy-policy" class="hover:text-text transition">Privacy Policy</router-link>
          <router-link to="/terms-of-service" class="hover:text-text transition">Terms of Service</router-link>
          <router-link to="/data-deletion" class="hover:text-text transition">Data Deletion</router-link>
          <a :href="infoMailto" class="hover:text-text transition">Contact</a>
        </nav>
      </div>
    </footer>
  </div>
  
</template>

<script>
import AppNavbar from './AppNavbar.vue';
import emailObfuscation from '@/mixins/emailObfuscation';

export default {
  name: 'Pricing',
  components: { AppNavbar },
  mixins: [emailObfuscation],
  methods: {
    showComingSoon() {
      alert('Coming soon...');
    }
  }
}
</script>


